import React, { Component } from 'react';
import { Map, List } from 'immutable';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex, Box } from 'grid-styled';

import { setViewstate, removeViewstate } from '../actions/actionCreators';
import connect from '../store/connect';
import { FilterOption } from '../styles/FilterOption';
import { filterColors } from '../constants/filterColors';

class FiltersList extends Component {
  getFilterOptions(type, filterArray) {
    return this.props.products
      .map(item => item.getIn(filterArray))
      .filter(item => typeof item !== 'undefined')
      .toSet()
      .sort((a, b) => {
        if (a.toLowerCase() < b.toLowerCase()) return -1;
        if (a.toLowerCase() > b.toLowerCase()) return 1;
        return 0;
      })
      .map(item => {
        if (!item) return false;

        return (
          <Box key={`key-${item}`} width={this.props.width} px={this.props.margin}>
            <FilterOption
              active={this.props.viewstate.getIn(['filter', type, item], false)}
              onClick={() => this.toggleFilter(type, item)}
            >
              {item}
            </FilterOption>
          </Box>
        );
      })
      .toArray();
  }

  getFilterOptionsForColor(type) {
    return this.props.products
      .map(item => item.getIn(['variants']))
      .map(item => item.reduce((memory, x) => memory.push(x.getIn(['filterColor'])), List()))
      .reduce((memory, item) => memory.push(...item), List())
      .toSet()
      .filter(item => filterColors[item])
      .sort((a, b) => {
        if (filterColors[a].name.toLowerCase() < filterColors[b].name.toLowerCase()) return -1;
        if (filterColors[a].name.toLowerCase() > filterColors[b].name.toLowerCase()) return 1;
        return 0;
      })
      .map(item => {
        if (!filterColors[item]) return false;

        return (
          <Box key={item} width={this.props.width} px={this.props.margin}>
            <FilterOption
              radioButton
              backgroundColor={filterColors[item].value}
              active={this.props.viewstate.getIn(['filter', type, item], false)}
              onClick={() => this.toggleFilter(type, item)}
            >
              {filterColors[item].name}
            </FilterOption>
          </Box>
        );
      })
      .toArray();
  }

  toggleFilter(type, id) {
    const filterExists = this.props.viewstate.hasIn(['filter', type, id]);

    if (type === 'color' && !filterExists && this.props.viewstate.hasIn(['filter', type])) {
      this.props.removeViewstate(['filter', type]);
      this.props.setViewstate(['filter', type, id], true);
    } else if (!filterExists) {
      this.props.setViewstate(['filter', type, id], true);
    } else {
      this.props.removeViewstate(['filter', type, id]);
    }
  }

  render() {
    const { type, selector, marginBottom, forColor } = this.props;
    const filters = forColor ? this.getFilterOptionsForColor(type, selector) : this.getFilterOptions(type, selector);

    return (
      <FullWidthFlex flexWrap="wrap" mb={marginBottom}>
        {filters.length > 0 ? filters : <NoFilterOptions>Inga tillgängliga filtreringsval</NoFilterOptions>}
      </FullWidthFlex>
    );
  }
}

const FullWidthFlex = styled(Flex)`
  width: 100%;
`;

const NoFilterOptions = styled.p`
  width: 100%;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.25;
`;

FiltersList.defaultProps = {
  margin: 40,
  marginBottom: 0,
  width: [1, 1 / 2, 1 / 3, 1 / 4],
  forColor: false
};

FiltersList.propTypes = {
  margin: PropTypes.number,
  marginBottom: PropTypes.number,
  width: PropTypes.array,
  products: PropTypes.instanceOf(Map).isRequired,
  viewstate: PropTypes.instanceOf(Map).isRequired,
  setViewstate: PropTypes.func.isRequired,
  removeViewstate: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  selector: PropTypes.array.isRequired,
  forColor: PropTypes.bool
};

export default connect(
  FiltersList,
  { setViewstate, removeViewstate },
  store => ({
    viewstate: store.viewstate
  })
);



// WEBPACK FOOTER //
// ./src/components/FiltersList.js